import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";

import vestigingStyle from "../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import * as actions from "../../store/actions";
import { DialogContext } from "../../licensing/utils/DialogProvider";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import { CloudUpload, Mail, Payment } from "@mui/icons-material";
import {
  JamezzTableDateField,
  JamezzTableLinkToRelation,
  JamezzTableValuta,
} from "../../components/JamezzTable/JamezzTableFields";
import Debtor from "../../licensing/Models/Debtor";
import Button from "../../components/CustomButtons/Button";
import DebtorFilter from "../../components/Filters/DebtorFilter";
import Invoice from "../../licensing/Models/Invoice";
import ControlledSelect from "../../components/CustomInput/ControlledSelect";
import { toast } from "react-toastify";

class SubsInvoicesIndex extends React.Component {
  state = {
    subs_debtors: [],

    selectedIds: [],

    copyModal: false,
    newModal: false,
  };

  jamezzTable = React.createRef();

  /**
   * Modal functies
   */
  toggleModal(modal) {
    let newState = { ...this.state };
    newState[modal] = !this.state[modal];
    this.setState(newState);
  }

  componentDidMount() {
    this.getSubsDebtors();
  }

  getSubsDebtors() {
    Debtor.index([]).then(({ models }) => {
      this.setState({
        subs_debtors: models.map((debtor) => ({ ...debtor, label: debtor.company_name, value: debtor.id })),
      });
    });
  }

  handleMultiSelect = (ids) => {
    this.setState({ selectedIds: ids });
  };

  mergeConcepts = () => {
    Invoice.mergeConcepts(this.state.selectedIds)
      .then((response) => {
        toast.success(response.data?.data?.message ?? "Ok");
        this.jamezzTable.current?.refreshData();
      })
      .catch(() => {
        toast.error("Error");
      });
  };

  render() {
    const actions = [
      {
        icon: CloudUpload,
        tooltip: <TranslationWrapper tKey={"Upload to Gripp"} />,
        action: (row) => {
          Invoice.uploadToGripp(row[0])
            .then((response) => {
              toast.success(response.data?.data?.message ?? "Ok");
              this.jamezzTable.current?.refreshData();
            })
            .catch(() => {
              toast.error("Error");
            });
        },
        show: (row) => {
          return !row[8];
        },
      },
      {
        icon: Mail,
        tooltip: <TranslationWrapper tKey={"Send invoice to debtor"} />,
        action: (row) => {
          Invoice.sendToDebtor(row[0])
            .then((response) => {
              toast.success(response.data?.data?.message ?? "Ok");
              this.jamezzTable.current?.refreshData();
            })
            .catch((err) => {
              toast.error("Error");
            });
        },
        show: (row) => {
          return !!row[8] && row[3] === "CONCEPT";
        },
      },
    ];

    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tKey={"Invoices"} />} />

        <GridContainer>
          <GridItem>
            <Button
              color={"primary"}
              onClick={() => {
                Invoice.generateInvoices().then(() => {});
              }}
            >
              <TranslationWrapper tKey={"Generate invoices"} />
            </Button>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem md={4} xs={12}>
            <DebtorFilter />
          </GridItem>
          <GridItem md={4} xs={12}>
            <ControlledSelect
              controlled={true}
              onHandleValue={(value) => {
                value = value === "ALL" ? null : value;

                if (value) {
                  this.props.setFilter("subs_invoices:status", {
                    field: "status",
                    operator: "=",
                    value: value,
                  });
                } else {
                  this.props.setFilter("subs_invoices:status", null);
                }
              }}
              options={[
                { value: "ALL", label: "All" },
                { value: "CONCEPT", label: "Concept" },
                { value: "SENT", label: "Sent" },
                { value: "PAID", label: "Paid" },
                { value: "PARTIALLY_PAID", label: "Partially paid" },
              ]}
              value={this.props.filters["subs_invoices:status"]?.value ?? "ALL"}
            />
          </GridItem>
        </GridContainer>

        {this.state.selectedIds.length > 1 &&
        this.props.filters.subs_debtor_id != null &&
        this.props.filters["subs_invoices:status"]?.value === "CONCEPT" ? (
          <Button color={"success"} onClick={() => this.mergeConcepts()}>
            <TranslationWrapper tKey={"Merge concepts"} />
          </Button>
        ) : null}

        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              actions={actions}
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "description", editable: false },
                { dbfield: "type", editable: false },
                { dbfield: "status", editable: false },
                new JamezzTableDateField("invoice_date", false),
                new JamezzTableValuta("amount_excl"),
                new JamezzTableLinkToRelation("subs_debtor.company_name", "/subsdebtors/:id/edit", {
                  id: "subs_debtor_id",
                }),
                { dbfield: "subs_debtor_id", hide: true },
                { dbfield: "gripp_reference", hide: true },
              ]}
              dbfields={
                "id,description,type,invoice_date_unix,invoice_date,subs_debtor_id,subs_debtor.id,subs_debtor.company_name,gripp_reference,status"
              }
              delete={false}
              editLink={"./:id/edit"}
              editLinkPermission={"subsinvoices/:id/edit"}
              fetchUrl={"core/subsInvoice"}
              filters={this.props.filters}
              headerIcon={<Payment />}
              headers={[
                {
                  label: getTranslation("#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("Description"),
                  sortable: true,
                  sortKey: "description",
                },
                {
                  label: getTranslation("Invoice"),
                  sortable: true,
                  sortKey: "type",
                },
                {
                  label: getTranslation("Status"),
                },
                {
                  label: getTranslation("Invoice date"),
                  sortable: true,
                  sortKey: "invoice_date_unix",
                },
                { label: getTranslation("Amount excl. VAT") },
                {
                  label: getTranslation("Debtor"),
                },
              ]}
              multieSelect={true}
              multieSelectHandler={this.handleMultiSelect}
              reduxKey={"subs_invoice"}
              ref={this.jamezzTable}
              tableTitle={<TranslationWrapper tKey={"Invoices"} />}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

SubsInvoicesIndex.propTypes = {
  classes: PropTypes.object,
};

SubsInvoicesIndex.contextType = DialogContext;

//REDUX
const mapStateToProps = (state) => {
  let filters = {};
  if (state.filtersV2.subs_debtor_id) {
    filters.subs_debtor_id = state.filtersV2.subs_debtor_id;
  }
  if (state.filtersV2["subs_invoices:status"]) {
    filters["subs_invoices:status"] = state.filtersV2["subs_invoices:status"];
  }
  return {
    filters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFilter: (key, filter) => {
      dispatch({
        type: actions.SET_FILTER,
        payload: { key, filter },
      });
    },
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(SubsInvoicesIndex, vestigingStyle));
